<button type="button"
  class="compound-button"
  [attr.id]="buttonId"
  [class.center-content]="!subtitle && !customSubtitle"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || title"
  [style.width]="width"
  [style.height]="height"
  (viUiAccessibleClick)="onButtonClick()">

  @if (customTitle) {
  <ng-container [ngTemplateOutlet]="customTitle" />
  } @else {
  <vi-ui-text class="title"
    [size]="titleSize"
    [color]="disabled ? disabledTitleColor : titleColor"
    [fontWeight]="600"
    [text]="title"
    [style.text-align]="textAlign" />
  }

  @if(subtitle || customSubtitle) {
  @if (customSubtitle) {
  <ng-container [ngTemplateOutlet]="customSubtitle" />
  } @else {
  <vi-ui-text class="subtitle"
    [size]="subtitleSize"
    [color]="disabled ? disabledSubtitleColor : subtitleColor"
    [text]="subtitle"
    [style.text-align]="textAlign" />
  }
  }
</button>
